<template>
	<div class="bpa-search-template-container">
		<div class="wrapper">
			<slot name="top-search" />

			<div class="d-grid">
				<div class="filters">
					<div class="filter-header">
						<slot name="filter-header" class="filter-header" />
					</div>
					<div :class="{ 'filter-container': true, 'active': show }" v-if="show">
						<button class="close" aria-label="Next" type="button" @click="closeModal">
							<img height="20" width="20" src="/wp-content/themes/bpa-health/dist/images/icons/icon-close.svg" />
						</button>
						<div class="inner-conatainer">
							<slot name="filter-container" class="filter-container" />
						</div>
					</div>
				</div>
				<div class="search-results">
					<slot name="search-container" class="search-container" />
				</div>
			</div>
		</div>

		<vue-progress-bar></vue-progress-bar>
	</div>
</template>

<script>
import axios from "axios"

export default {
	props: {
		show: {
			default: true,
			type: Boolean
		}
	},
	data () {
		return {
			isOpen: false,
		}
	},
	created () {
		axios.interceptors.request.use( ( config ) => {
			this.$Progress.start()
			return config
		}, ( error ) => {
			this.$Progress.finish()
			return Promise.reject( error )
		} )

		axios.interceptors.response.use( ( response ) => {
			this.$Progress.finish()
			return response.data
		}, ( error ) => {
			this.$Progress.finish()
			return Promise.reject( error )
		} )
	},
	methods: {
		closeModal () {
			this.$emit( 'closeFilter' )
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../sass/variables";
@import "../sass/mixins";

.filter-container>.clear-link {
	margin-bottom: 16px;
}

.filter-header {
	@include xl {
		width: calc(100% - 16px);
		margin: 0 auto;
	}
}

.filter-container {
	margin-top: 20px;

	@include xl {
		animation-duration: .1s;
		animation-iteration-count: 1;
		animation-name: fade-in-opacity;
		animation-timing-function: ease-in;
		backdrop-filter: blur(4px);
		background: rgba(3, 4, 21, .7);
		bottom: 0;
		display: none;
		left: 0;
		opacity: 0;
		overflow-x: hidden;
		overflow-y: auto;
		padding: 90px 16px;
		pointer-events: none;
		position: fixed;
		right: 0;
		top: 0;
		z-index: 999999;
	}

	&.active {
		@include xl {
			display: block;
			opacity: 1;
			margin: 0;
		}
	}

	.close {
		display: none;

		@include xl {
			pointer-events: all;
			display: block;
			position: absolute;
			top: 100px;
			right: 32px;
			border: none;
			background: none;
			z-index: 2;
		}
	}

	.inner-conatainer {
		@include xl {
			position: relative;
			padding: 32px;
			background-color: #fff;
			border-radius: 10px;
			pointer-events: auto;
			height: calc(100vh - 125px);
			overflow: scroll;
		}

		* {
			@include xl {
				pointer-events: all;
			}
		}
	}
}
</style>